// export async function getTaddy(
//   timeoutMs = 8000
// ): Promise<NonNullable<Window["Taddy"]>> {
//   // дернем Telegram WebApp.ready (на всякий)
//   try {
//     window.Telegram?.WebApp?.ready?.();
//   } catch {}

//   const start = Date.now();
//   return new Promise((resolve, reject) => {
//     const tick = () => {
//       const taddy = window.Taddy;
//       if (taddy && typeof taddy.exchange === "function") {
//         taddy.ready?.();
//         return resolve(taddy);
//       }
//       if (Date.now() - start > timeoutMs) {
//         return reject(new Error("Taddy SDK not ready"));
//       }
//       setTimeout(tick, 50);
//     };
//     tick();
//   });
// }

import { checkTask, claimTask } from '../../../Requests/tasks/tasks';
import { SubgramAdapter, type TaskDetails } from './adapters/subgramAdapter';
import { SponsorsTasksAdapter } from './PartnerTasksAdapter';
import { useNotificationStore } from '../../../store/NotificationStore';
import { useBalanceStore } from '../../../store/BalanceStore';
import { usePartnerTasksStore } from '../../../store/PartnerTasksStore';
import { FlyerAdapter } from './adapters/FlyerAdapter';
enum SponsorType {
  BARZHA = 'barzha',
  TAPPADS = 'tappads',
  DREAMCOIN_CLICK = 'dreamcoin_click',
  DREAMCOIN_SUBSCRIBE = 'dreamcoin_subscribe',
  BARZHA_CLICK = 'barzha_click',
  FLYER = 'flyer',
  SUBGRAM = 'subgram',
  TADDY = 'taddy',
}
interface SponsorProvider {
  type: SponsorType;
  getTasks: () => Promise<TaskDetails[]>;
}
export class SponsorsService {
  private static sponsorTasks: TaskDetails[] = [];

  static async getSponsorTasks(): Promise<TaskDetails[]> {
    try {
      console.log('🚀 SponsorsService.getSponsorTasks - start');

      // Определяем провайдеры заданий
      const sponsorProviders: SponsorProvider[] = [
        {
          type: SponsorType.SUBGRAM,
          getTasks: async () => {
            try {
              const [subgramTasks, subgramStatusTasks] = await Promise.all([
                SubgramAdapter.getFeed(),
                SubgramAdapter.getStatusTasks(),
              ]);

              console.log('📦 Получены задания от Subgram:', {
                subgramTasks,
                subgramStatusTasks,
              });

              return SponsorsTasksAdapter.adaptTasks(
                SponsorType.SUBGRAM,
                subgramTasks,
                subgramStatusTasks,
              );
            } catch (error) {
              console.error('❌ Ошибка получения заданий от Flyer:', error);
              return [];
            }
          },
        },
        {
          type: SponsorType.FLYER,
          getTasks: async () => {
            try {
              const [flyerTasks, flyerStatusTasks] = await Promise.all([
                FlyerAdapter.getFeed(),
                FlyerAdapter.getStatusTasks(),
              ]);

              console.log('📦 Получены задания от Flyer:', {
                flyerTasks,
                flyerStatusTasks,
              });

              return SponsorsTasksAdapter.adaptTasks(
                SponsorType.FLYER,
                flyerTasks,
                flyerStatusTasks,
              );
            } catch (error) {
              console.error('❌ Ошибка получения заданий от Flyer:', error);
              return [];
            }
          },
        },
      ];

      // Получаем задания от всех провайдеров параллельно
      const tasksPromises = sponsorProviders.map((provider) =>
        provider.getTasks().catch((error) => {
          console.error(
            `❌ Ошибка получения заданий от ${provider.type}:`,
            error,
          );
          return [];
        }),
      );

      const tasksArrays = await Promise.all(tasksPromises);

      const allTasks = tasksArrays.flat();

      // Сортировка заданий по статусу
      //   const sortedTasks = this.sortTasksByStatus(allTasks);
      const sortedTasks = allTasks;
      // Сохраняем задания в памяти
      this.sponsorTasks = sortedTasks;

      console.log('📋 Адаптированные и отсортированные задания:', sortedTasks);

      return sortedTasks;
    } catch (error) {
      console.error('❌ SponsorsService.getSponsorTasks - error:', error);
      throw error;
    }
  }

  //   private static sortTasksByStatus(tasks: DailyTask[]): DailyTask[] {
  //     const statusPriority: Record<TaskStatus, number> = {
  //       NOT_STARTED: 1,
  //       IN_PROGRESS: 2,
  //       WAITING: 3,
  //       DONE: 4,
  //       CLAIMED: 5,
  //     };

  //     return [...tasks].sort((a, b) => {
  //       return statusPriority[a.status] - statusPriority[b.status];
  //     });
  //   }

  static async claimSponsorTask(
    taskId: number | string,
  ): Promise<boolean | string | { success: boolean; completed: boolean }> {
    try {
      const task = this.sponsorTasks.find((task) => task.id === taskId);
      console.log('🚀 SponsorsService.claimSponsorTask - task', task);

      if (!task) {
        console.warn('⚠️ Task not found with ID:', taskId);
        return false;
      }
      let rewardAmount = 0;
      let waiting = false;
      let done = false;
      let success = false;

      switch (task.provider) {
        case 'SUBGRAM': {
          const res = await claimTask('partner', taskId, 'subgram');
          const setBalance = useBalanceStore.getState().setBalance;
          const balance = useBalanceStore.getState().balance;
          console.log('resssssssssssssssssssss', res);
          if (res) {
            success = true;
            if (res.wallet.beastcoins) {
              rewardAmount = res.wallet.beastcoins - balance;
              setBalance(res.wallet.beastcoins);
            }
          }

          break;
        }
        case 'FLYER': {
          if (task.status === 'DONE') {
            const res = await claimTask('partner', taskId, 'flyer');
            console.log('res', res);
            const balance = useBalanceStore.getState().balance;
            const setBalance = useBalanceStore.getState().setBalance;
            if (res) {
              success = true;

              if (res.wallet.beastcoins) {
                rewardAmount = res.wallet.beastcoins - balance;
                setBalance(res.wallet.beastcoins);
              }
            }
            break;
          } else {
            const res = await checkTask('partner', taskId, 'flyer');
            if (res) {
              if (res.status === 'WAITING') {
                waiting = true;
              } else if (res.status === 'DONE') {
                done = true;
              } else if (res.status === 'CLAIMED') {
                success = true;
              }
            }
            break;
          }
        }
        default:
          console.warn('⚠️ Unknown sponsor provider:', task.provider);
          return false;
      }

      const setNotification = useNotificationStore.getState().setNotification;
      const updateTaskStatus = usePartnerTasksStore.getState().updateTaskStatus;

      if (waiting) {
        updateTaskStatus(taskId.toString(), 'WAITING');
        setNotification({
          type: 'Warning',
          message: 'Задание на проверке.\nНе отписывайтесь 24 часа.',
        });
        return 'WAITING';
      } else if (done) {
        updateTaskStatus(taskId.toString(), 'DONE');
        return 'DONE';
      } else if (success) {
        // Обновляем статус задания в кэше
        updateTaskStatus(taskId.toString(), 'CLAIMED');

        // Убедимся, что тип награды соответствует ожидаемому формату
        // Если тип 'ticket', изменим его на 'tickets' для совместимости
        // const normalizedRewardType =
        //   rewardType === 'ticket' ? 'tickets' : rewardType;
        console.log(rewardAmount, 'rewardAmount');
        setNotification({
          type: 'Success',
          message: 'Награда за задание получена!',
          rewards: rewardAmount > 0 ? [{ amount: rewardAmount }] : undefined,
        });
        return { success: true, completed: true };
      } else {
        setNotification({
          type: 'Error',
          message: 'Задание на проверке. Повтори через 30 секунд.',
        });
        console.log('false');
        return false;
      }
    } catch (error) {
      const task = this.sponsorTasks.find((task) => task.id === taskId);

      if (!task) {
        console.warn('⚠️ Task not found with ID:', taskId);
        return false;
      }

      console.error('❌ SponsorsService.claimSponsorTask - error', error);
      //   const setNotification = useNotificationStore.getState().setNotification;

      //   if (task.provider === 'FLYER') {
      //     setNotification({
      //       type: 'Error',
      //       message: 'Задание не выполнено.',
      //     });
      //   } else {
      //     setNotification({
      //       type: 'Error',
      //       message: 'Задание на проверке. Повтори через 30 секунд.',
      //     });
      //   }
      return false;
    }
  }

  // Добавляем метод для обновления статуса задания
  // private static updateTaskStatus(
  //   taskId: number | string,
  //   status: TaskStatus,
  // ): void {
  //   const taskIndex = this.sponsorTasks.findIndex((task) => task.id === taskId);
  //   if (taskIndex !== -1) {
  //     this.sponsorTasks[taskIndex] = {
  //       ...this.sponsorTasks[taskIndex],
  //       status,
  //     };
  //     console.log(`✅ Статус задания ${taskId} обновлен на ${status}`);

  //     // Синхронизируем с основным стором приложения
  //     try {
  //       const { tasks } = useTasksStore.getState();
  //       const updatedTasks = tasks.map((task) =>
  //         task.id === taskId ? { ...task, status } : task,
  //       );
  //       useTasksStore.getState().setTasks(updatedTasks);
  //       console.log(
  //         `🔄 Статус задания ${taskId} синхронизирован с основным стором`,
  //       );
  //     } catch (error) {
  //       console.warn(
  //         `⚠️ Не удалось синхронизировать статус задания ${taskId} с основным стором:`,
  //         error,
  //       );
  //     }
  //   }
  // }
}
